module.exports = { "default": require("core-js/library/fn/promise"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./src/frontend-lib/~/babel-runtime/core-js/promise.js
// module id = KLAo
// module chunks = 0